import {useRef} from 'react';

/**
 * This hook is used to run a callback the first time a condition is met, and never again until the component is re-mounted
 * @param condition The condition to be met
 * @param callback The callback to be run when the condition is met
 */
const useExecuteFirstTimeConditionIsMet = (
  condition: boolean,
  callback: () => void,
): void => {
  const ref = useRef(true);
  // eslint-disable-next-line react-hooks/refs
  if (ref.current && condition) {
    // eslint-disable-next-line react-hooks/refs
    ref.current = false;
    callback();
  }
};

export default useExecuteFirstTimeConditionIsMet;
